import { render, staticRenderFns } from "./CartPreview.vue?vue&type=template&id=225d9208&scoped=true&"
import script from "./CartPreview.vue?vue&type=script&lang=js&"
export * from "./CartPreview.vue?vue&type=script&lang=js&"
import style0 from "./CartPreview.vue?vue&type=style&index=0&id=225d9208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225d9208",
  null
  
)

export default component.exports